var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lc-date-range-search"},[_c('span',{staticClass:"quicktime-search"},[_vm._v(_vm._s(_vm.label))]),_c('lc-date-range-picker',{staticClass:"date-range-picker",attrs:{"clearable":""},on:{"change":_vm.handleDateRangeChange},model:{value:(_vm.dateRange),callback:function ($$v) {_vm.dateRange=$$v},expression:"dateRange"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }